import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-InvoiceCenter",
  "use": "icon-InvoiceCenter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-InvoiceCenter\">\n  <path d=\"M6.5 3.8h11a1.5 1.5 0 0 1 1.5 1.5v16l-2.7-1.5-2.7 1.5-2.7-1.5-2.7 1.5-2.7-1.5v-16a1.5 1.5 0 0 1 1.5-1.5Z\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\" />\n  <path d=\"M9 8h6M9 12h6M9 16h3\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol